import AlertCreatorFormPanel from '../../features/AlertCreator/components/AlertCreatorFormPanel/AlertCreatorFormPanel';
import AlertMapEditor from '../../features/AlertCreator/features/AlertMapEditor/index.web';

const AlertCreatorWidget = ({ layout }) => {
  const isWide = layout === '2x1';

  // Derived classes/styles for a single render path.
  const containerClass = isWide
    ? 'd-flex flex-row h-100 overflow-hidden gap-3 align-items-stretch' //w ide version
    : 'd-flex flex-column h-100 gap-3 align-items-stretch'; // tall version

  const mapWrapperClass = isWide ? 'h-100 min-h-0' : 'w-100 min-h-0';
  const mapWrapperStyle = isWide
    ? { flex: '0 0 60%', minWidth: 0 }
    : { flex: '1 1 60%', minWidth: 0 };

  const formClass = isWide ? 'overflow-auto min-h-0' : 'w-100 overflow-auto min-h-0';
  const formStyle = { flex: isWide ? '1 1 40%' : '1 1 40%', minWidth: 0 };

  return (
    <div className={`alert-creator-widget ${containerClass}`}>
      <div className={mapWrapperClass} style={mapWrapperStyle}>
        <AlertMapEditor fillContainer={true} />
      </div>
      <div className={formClass} style={formStyle}>
        <AlertCreatorFormPanel widget={true} />
      </div>
    </div>
  );
};

export default AlertCreatorWidget;
